<script setup lang="ts">
import type { LocationQueryValueRaw } from '#vue-router'
import FacebookLogo from '@/assets/facebook-logo.svg?component'

interface Props {
  redirect?: string
}

const { redirect = '/u/moje-konto' } = defineProps<Props>()

const runtimeConfig = useRuntimeConfig()
const route = useRoute()
const cartStore = useCartStore()
const guestTokenCookie = useCookie('token')

const login = async () => {
  // Pass guest token through OAuth state parameter to preserve cart reference
  const state = guestTokenCookie.value || ''
  await navigateTo({
    path: 'https://facebook.com/v2.12/dialog/oauth',
    query: {
      protocol: 'oauth2',
      response_type: 'code',
      client_id: runtimeConfig.public.facebookClientID as LocationQueryValueRaw,
      redirect_uri: `${runtimeConfig.public.baseUrl}/u/logowanie`,
      scope: 'public_profile email',
      code_challenge_method: '',
      state
    }
  }, { external: true })
}
const token = useCookie('auth.token')
if (route.query.code && !route.query.scope?.toString().includes('google')) {
  const response = await $fetch('/facebook-login', {
    method: 'POST',
    body: {
      code: route.query.code,
      guestToken: route.query.state // Guest token passed through OAuth state
    }
  })
  token.value = response
  // Refresh cart store to reflect merged cart contents
  await cartStore.init()
  await navigateTo(redirect)
}
</script>

<template>
  <button class="flex items-center w-full h-[40px] bg-[#1877F2] rounded-[40px] text-14 text-white px-[15px]" @click="login()">
    <FacebookLogo class="fill-white" />
    <span class="w-full">Użyj konta Facebook</span>
  </button>
</template>
